import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { capitalizeFirstLetter } from "src/services/utils/string.utils";
import { CardService } from "src/services/card/card.service";
import { LoadingService } from "src/services/loading/loading.service";
import { Stripe } from "stripe";

@Component({
  selector: "rc-credit-card",
  templateUrl: "./credit-card.component.html",
  styleUrls: ["./credit-card.component.scss"],
  standalone: false,
})
export class CreditCardComponent implements OnInit {
  @Input() public paymentMethod: Stripe.PaymentMethod & { brandDisplayName?: string };
  @Input() public isActiveOnSubscription: boolean;

  @Output() public onClickValidCard = new EventEmitter<Stripe.PaymentMethod>();

  public cardDeleted = false;

  constructor(
    private readonly cardService: CardService,
    private readonly loadingService: LoadingService,
  ) {}

  public ngOnInit() {
    if (this.paymentMethod?.card?.brand) {
      this.paymentMethod.brandDisplayName = capitalizeFirstLetter(this.paymentMethod.card.brand);
    }
  }

  public isExpired(): boolean {
    const card = this.paymentMethod.card;
    if (!card) {
      return false;
    }

    const now = new Date();
    const yearBeforeCurrent = card.exp_year < now.getFullYear();
    const yearIsThisYear = card.exp_year === now.getFullYear();
    return yearBeforeCurrent || (yearIsThisYear && card.exp_month <= now.getMonth() + 1);
  }

  public async deleteCard(): Promise<void> {
    await this.loadingService.wrapInLoading(async () => {
      await this.cardService.deleteCard(this.paymentMethod.id);
      this.cardDeleted = true;
    });
  }

  public isUnknownCardBrand(): boolean {
    const brand = this.paymentMethod.card?.brand;
    return brand !== "amex" && brand !== "jcb" && brand !== "mastercard" && brand !== "visa";
  }
}
